import React from 'react';
import { wrapReactionHook } from "../../hooks";
export var Collapse = wrapReactionHook(function (props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("div", null, "Collapse", children);
});